module.exports = __webpack_public_path__ + "img/Frame 138@2x.058012e0.png";